// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_aTb","cls2":"Comments-cls2_gYp Comments-cls1_aTb"};